import React from 'react';
import * as PropTypes from 'prop-types';
import classNames from 'classnames';

import './steps.scss';

export const Step = ({ label, index, isCurrent }) => (
  <div className={classNames('steps__item', { 'steps__item--current': isCurrent })}>
    <div className="steps__label">
      <p className="steps__label__paragraph">{index}</p>
      <p className="steps__label__paragraph">{label}</p>
    </div>
  </div>
);

Step.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  index: PropTypes.number,
  isCurrent: PropTypes.bool,
};

export default Step;
